import { render, staticRenderFns } from "./KisDefectEditDialog.vue?vue&type=template&id=947f38fe"
import script from "./KisDefectEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisDefectEditDialog.js?vue&type=script&lang=js&external"
import style0 from "./KisDefectEditDialog.vue?vue&type=style&index=0&id=947f38fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports